import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";

import PageAllDevices from "../Devices/AllDevices/PageAllDevices";

class Profile extends Component {
  
  render() {
    const { user: currentUser } = this.props;
    console.log(this.props)

    if (!currentUser) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="container">
        <header className="jumbotron">
          <h3>
            <strong>{currentUser.username}</strong> Profile
          </h3>
        </header>
{/*         <PageAllDevices 
        
        /> */}

{/*         <p>
          <strong>Token:</strong> {currentUser.accessToken.substring(0, 20)} ...{" "}
          {currentUser.accessToken.substr(currentUser.accessToken.length - 20)}
        </p>
        <p>Hello!</p>
        <p>
          <strong>Id:</strong> {currentUser.id}
        </p>
        <p>
          <strong>Email:</strong> {currentUser.email}
        </p>
        <p>
          <strong>Chat_id:</strong> {currentUser.chat_id}
        </p>
        <p>
          <strong>Test:</strong> {this.props.test.h}
        </p>
        <strong>Authorities:</strong>
        <ul>
          {currentUser.roles &&
            currentUser.roles.map((role, index) => <li key={index}>{role}</li>)}
        </ul>

        <h1>Hello  JSON Show!</h1>
        <div><pre>{JSON.stringify(this.props, null, 2) }</pre></div>; */}

      </div>
    );
  }
}

function mapStateToProps(state) {
  console.log(state)
  console.log(state.auth)
  const { user, test } = state.auth;
  return {
    user,
    test
  };

}

export default connect(mapStateToProps)(Profile);
